export default __webpack_public_path__ + "static/media/loading.ca11b468.gif";